/**
 * How money for fabric reaches us.
 *
 * One list, because it is asked for in two places — on the sale drawer in the
 * Fabric Store, where payment comes in with the cloth, and on the Payments page,
 * where a buyer settles their account later. The two screens offered separate
 * copies of this and would have drifted the first time either gained a method.
 *
 * "Courier" is money the courier collected on delivery and remitted to us; it is
 * the buyer paying, not a courier charge.
 *
 * The column behind it is a free string (`payment_method`, 32 chars) with no
 * server-side enum, so a row recorded before a method joined this list keeps
 * whatever it was saved with, and every screen that displays one prints what it
 * finds rather than looking it up here.
 */
export const PAYMENT_METHODS = ['Cash', 'Bank', 'Bkash', 'Courier'];

/** The same list shaped for an antd `Select`. */
export const PAYMENT_METHOD_OPTIONS = PAYMENT_METHODS.map((m) => ({ value: m, label: m }));
